import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/lib/neoscriber/publish/node_modules/@mui/material/Box/Box.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/lib/neoscriber/publish/src/components/common/_partials/footer/footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/lib/neoscriber/publish/src/components/common/button-to-start/button-to-start.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/lib/neoscriber/publish/src/components/common/gradient-box/gradient-box.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/lib/neoscriber/publish/src/components/common/service/online-chat/online-chat-alternative.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/lib/neoscriber/publish/src/components/common/service/online-chat/online-chat.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/lib/neoscriber/publish/src/components/main-site/_partials/header/main-header.tsx");
